import Dropdown from "../../atoms/Dropdown/Dropdown";

interface Filter {
  title?: string;
  className?: string;
  options: { label: string; value: string }[];
  label?: string;
  id: string;
}

interface FiltersGroupProps {
  className?: string;
  filters: Filter[];
  handleFilterChange: (event: string, filterId: string) => void;
}

const FiltersGroup = (props: FiltersGroupProps) => {
  const { className, filters, handleFilterChange } = props;

  return (
    <fieldset className={`flex flex-row ${className ?? ""}`}>
      {filters && filters.length
        ? filters.map((filter, key) => (
            <Dropdown
              key={key}
              label={filter.label}
              options={filter.options}
              onChange={(event) => handleFilterChange(event, filter.id)}
            />
          ))
        : null}
    </fieldset>
  );
};

FiltersGroup.displayName = "FiltersGroup";

export default FiltersGroup;
export type { FiltersGroupProps };
